import { useAutoAnimate } from "@formkit/auto-animate/react";
import { UserMemberBean } from "@gymflow/types";
import { FormikContextType, FormikProvider } from "formik";
import { useCallback } from "react";

import {
  FormPaymentMethodPicker,
  FormSelectCustomPaymentCategory,
  Tabs,
} from "../atoms";
import {
  ShopSidebarFormValues,
  TABS,
  TabsType,
} from "./ShopSidebar/ShopSidebarProvider";

export type ShopCheckoutPaymentProps = {
  selectedUser: UserMemberBean;
  formik: FormikContextType<ShopSidebarFormValues>;
  setActiveTabId: (value: TabsType) => void;
  activeTabId: TabsType;
  customPaymentsEnabled: boolean;
};

export const ShopCheckoutPayment = ({
  selectedUser,
  formik,
  setActiveTabId,
  activeTabId,
  customPaymentsEnabled,
}: ShopCheckoutPaymentProps) => {
  const [parent] = useAutoAnimate();

  // TODO: refactor it (after redesign the sidebar)
  const onPressTab = useCallback(
    (value: TabsType) => {
      setActiveTabId(value);
      formik.setFieldValue("inPersonPaymentMethod", undefined);
    },
    [formik, setActiveTabId],
  );

  return customPaymentsEnabled ? (
    <FormikProvider value={formik}>
      <div className="shadow-xs flex flex-col gap-5 rounded-2xl border border-gray-200 bg-gray-50 p-3">
        <Tabs
          tabs={TABS}
          activeTabId={activeTabId}
          setActiveTabId={(id) => onPressTab(id)}
          className="justify-evenly gap-3 border-b-gray-300 pb-5"
          tabClassName="py-2.5 px-3 rounded-xl max-w-none w-full items-center justify-center bg-gray-0 border border-gray-200"
          activeTabClassName="bg-secondary-25 border border-secondary-700"
          activeTabLabelClassName="text-secondary-700"
        />
        <div ref={parent}>
          {activeTabId === "ONLINE" ? (
            <FormPaymentMethodPicker
              name="paymentMethodId"
              userMemberId={selectedUser.id}
              customLabel="Select payment method"
              allowBankPayment
            />
          ) : (
            <FormSelectCustomPaymentCategory
              name="inPersonPaymentMethod"
              label="Select payment method"
              labelClassName="text-base"
            />
          )}
        </div>
      </div>
    </FormikProvider>
  ) : (
    <FormPaymentMethodPicker
      name="paymentMethodId"
      userMemberId={selectedUser.id}
      allowBankPayment
    />
  );
};
